<template>
  <section class="is-card">
    <h2 class="font-lg is-bolder">
      Produção
    </h2>
    <div class="production-header">
      <h3 class="font-md is-bold">
        Propostas
      </h3>
      <BaseSelect
        v-model="form.product_id"
        :options="list.products"
        @input="getProposalResume"
      >
        Produto
      </BaseSelect>
    </div>
    <div class="production-data">
      <div
        v-for="(item, index) in form.statusData"
        :key="index"
        class="data-box"
        :class="{
          'data-box--info': item.status === 'Digitadas',
          'data-box--warning': item.status === 'Pendência',
          'data-box--danger': item.status === 'Cancelada',
          'data-box--success': item.status === 'Paga',
        }"
        @click="openProposalList(item.status)"
      >
        <p class="font-sm is-semi-bold">
          {{ item.status }}
        </p>
        <p class="font-lg is-bold">
          {{ item.total }}

          <LinkIcon />
        </p>
      </div>
    </div>
    <p class="production-footer font-sm">
      Propostas das últimas 24 horas
    </p>

    <div class="financial-area">
      <h2 class="font-md is-bold">
        Financeiro
      </h2>
      <button
        class="button"
        @click="openFinancialPage"
      >
        <DollarSignIcon /> Ver Financeiro
      </button>
    </div>
  </section>
</template>
<script>
import config from '@/data/config';

import loadingMixin from '@/mixins/loadingView.mixin';

import LinkIcon from '@/assets/icons/Link.vue';
import DollarSignIcon from '@/assets/icons/DollarSign.vue';
import BaseSelect from '@/components/Base/Select/index.vue';

import {
  products as productsAPI,
  proposals as proposalsAPI,
} from '@/services';

export default {
  name: 'ProductionSection',
  components: {
    DollarSignIcon,
    LinkIcon,
    BaseSelect,
  },
  mixins: [
    loadingMixin,
  ],
  data() {
    return {
      list: {
        products: [],
      },
      form: {
        product_id: config.PRODUCT_ID_FGTS,
        statusData: [
          { status: 'Digitadas', total: 0 },
          { status: 'Pendência', total: 0 },
          { status: 'Paga', total: 0 },
          { status: 'Cancelada', total: 0 },
        ],
      },
    };
  },
  async mounted() {
    await this.fetchProducts();
    await this.getProposalResume();
  },
  methods: {
    // Handlers
    openProposalList(status) {
      sessionStorage.setItem('filters', JSON.stringify(
        {
          status,
        },
      ));

      const { href } = this.$router.resolve({ name: 'fgts-proposal' });
      window.open(href, '_blank');
    },
    openFinancialPage() {
      this.$router.push({ name: 'promoters-commission' });
    },

    // API
    async fetchProducts() {
      this.loading = true;

      await productsAPI
        .getProducts()
        .then(({ data }) => {
          for (const { id, name } of data.data) {
            const shortCypher = {
              'Consignado Privador': 'CLT',
              'Crédito pessoal com limite do cartão em garantia': 'Cartão',
              'Crédito pessoal com veículo em garantia': 'CGV',
            };

            const usedName = shortCypher[name] || name;

            this.list.products.push({
              name: usedName,
              value: id,
            });
          }
        })
        .catch((err) => this.handlerError(err))
        .finally(() => {
          this.loading = false;
        });
    },
    async getProposalResume() {
      this.loading = true;
      const params = {
        last_day: true,
        product: this.form.product_id,
      };
      await proposalsAPI
        .getStatusResume(params)
        .then(({ data }) => {
          const statusToAdd = [
            'Digitadas',
            'Pendência',
            'Paga',
            'Cancelada',
          ];

          const filteredStatus = data.filter((item) => {
            if (statusToAdd.includes(item.status)) return true;
          });

          this.$set(this.form, 'statusData', filteredStatus);
        })
        .catch(this.handlerError)
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/src/_textVariables.scss';
@import '@/assets/scss/src/_buttonsVariables.scss';

.financial-area {
  margin: 24px 0;
  display: flex;
  flex-direction: column;

  button {
    width: 300px;
    margin: 16px auto;

    svg {
      stroke: none;
      margin-right: 8px;
    }
  }
}

.production-header {
  margin: 24px 0;
  display: flex;
  justify-content: space-between;

  .control {
    display: flex;

    &::v-deep {
      label span {
        font-size: 16px;
        vertical-align: middle;
        margin-right: 8px;
      }
      .select {
        max-width: 95px;
      }
    }
  }
}
.production-footer {
  margin: 8px 0;
  color: #666666;
}

.production-data {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: space-around;

  .data-box {
    flex-grow: 0;
    flex-shrink: 1;
    padding: 16px;
    border-radius: 8px;
    min-width: 40%;
    max-width: 140px;
    min-height: 90px;
    text-align: center;
    cursor: pointer;

    p:last-child {
      line-height: 32px;
      margin-top: 4px;
    }

    &--info {
      order: 0;
      border: 1px solid $slate-200;
      background: $slate-50;

      p:last-child {
        color: $blue-700

        svg {
          margin-left: 4px;
        }
      }
    }

    &--warning {
      order: 1;
      border-radius: 8px;
      border: 1px solid $amber-100;
      background: #FFFCF2;

      p:last-child {
        color: #92400E;
      }
    }

    &--danger {
      order: 3;
      border: 1px solid $red-200;
      background: $red-50;

      p:last-child {
        color: $red-600;
      }
    }

    &--success {
      order: 2;
      border: 1px solid $green-200;
      background: $green-50;

      p:last-child {
        color: #065F46;
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  .production-data {
    .data-box {
      flex-grow: 1;
      min-width: 23%;
    }
  }
  .financial-area {
    button {
      margin: 16px 0;
    }
  }
}
</style>
